import React from 'react'
import { Mobile } from '../../shared/responsive-breakpoints'
import StethoscopeSVG from '../../shared/icons/StethoscopeSVG'
import IVBagSVG from '../../shared/icons/IVBagSVG'
import MedicalLogoSVG from '../../shared/icons/MedicalLogoSVG'
import MedicalBagSVG from '../../shared/icons/MedicalBagSVG'
import HealthcareWorkerSVG from '../../shared/icons/HealthcareWorkerSVG'
import AmbulanceSVG from '../../shared/icons/AmbulanceSVG'

const HomeWeServeItem = ({ serviced, isActive, changeActiveServiced }) => {
  const getIcon = icon => {
    switch (icon) {
      case 'StethoscopeSVG':
        return <StethoscopeSVG className="dealmed-home-serve__icon" />
      case 'IVBagSVG':
        return <IVBagSVG className="dealmed-home-serve__icon" />
      case 'MedicalLogoSVG':
        return <MedicalLogoSVG className="dealmed-home-serve__icon" />
      case 'HealthcareWorkerSVG':
        return <HealthcareWorkerSVG className="dealmed-home-serve__icon" />
      case 'MedicalBagSVG':
        return <MedicalBagSVG className="dealmed-home-serve__icon" />
      case 'AmbulanceSVG':
        return <AmbulanceSVG className="dealmed-home-serve__icon" />
      default:
        break
    }
  }

  return (
    <li
      className={
        isActive
          ? 'dealmed-home-serve__item dealmed-home-serve__item--active'
          : 'dealmed-home-serve__item'
      }
    >
      <button
        type="button"
        className={
          isActive
            ? 'dealmed-home-serve__button dealmed-home-serve__button--active'
            : 'dealmed-home-serve__button'
        }
        onClick={() => changeActiveServiced(serviced)}
      >
        <Mobile>
          <span className="dealmed-home-serve__icon-wrapper">{getIcon(serviced.icon)}</span>
        </Mobile>
        {serviced.text}
      </button>
    </li>
  )
}

export default HomeWeServeItem
